var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAiFillSparkles = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_804_8983)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.8465 3.82435L12.7667 3.61167L12.5541 3.53187L11.1366 3L12.5541 2.46813L12.7667 2.38833L12.8465 2.17565L13.3784 0.758169L13.9103 2.17565L13.9901 2.38833L14.2028 2.46813L15.6202 3L14.2028 3.53187L13.9901 3.61167L13.9103 3.82435L13.3784 5.24183L12.8465 3.82435ZM4.68524 6.06326L6.33467 2.502L7.98075 6.06591L8.05797 6.2331L8.22519 6.31025L11.7858 7.95313L8.22189 9.5992L8.0548 9.67638L7.97762 9.84347L6.33154 13.4074L4.68867 9.84677L4.61151 9.67955L4.44432 9.60233L0.878698 7.95545L0.878701 7.95545L0.878446 7.95533C0.878481 7.95477 0.878547 7.95431 0.87862 7.95396L0.87885 7.95385L4.44135 6.30698L4.60806 6.22991L4.68524 6.06326ZM11.7897 7.95134L11.7896 7.95134L11.7897 7.95134ZM12.5541 12.4681L12.7667 12.3883L12.8465 12.1757L13.3784 10.7582L13.9103 12.1757L13.9901 12.3883L14.2028 12.4681L15.6202 13L14.2028 13.5319L13.9901 13.6117L13.9103 13.8243L13.3784 15.2418L12.8465 13.8243L12.7667 13.6117L12.5541 13.5319L11.1366 13L12.5541 12.4681Z",
  stroke: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_804_8983"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.378418)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAiFillSparkles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ai-fill-sparkles.36115e3108a015685abf557eec493b32.svg";